import {Brick, registerBrick} from 'olympe';
import UserDefaults from '../../models/cloudobjects/UserDefaults';

/**
 * This brick check if a User Default object is completely empty
 */
export default class IsUserDefaultsEmpty extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {UserDefaults} userDefaults
     * @param {function()} forwardEvent
     * @param {function(boolean)} setIsEmpty
     */
    update($, [userDefaults], [forwardEvent, setIsEmpty]) {
        if (userDefaults instanceof UserDefaults) {
            setIsEmpty(
                !userDefaults.getPurchOrg() &&
                !userDefaults.getAccountType() &&
                !userDefaults.getCompCode() &&
                !userDefaults.getPurchGroup() &&
                !userDefaults.getAccountNumber() &&
                !userDefaults.getPlant() &&
                !userDefaults.getStorageLocation() &&
                !userDefaults.getGLAccount() &&
                !userDefaults.getTaxCode() &&
                !userDefaults.getCurrency() &&
                !userDefaults.getWBSProject() &&
                !userDefaults.getCostCenter() &&
                !userDefaults.getProfitCenter() &&
                !userDefaults.getDeliveryAddress() &&
                !userDefaults.getSpender() &&
                !userDefaults.getRequester() &&
                !userDefaults.getHidePrice());
        } else {
            console.error('Given object is not a User Defaults');
        }
        forwardEvent();
    }
}

registerBrick('0190fde6ac463f50cef5', IsUserDefaultsEmpty);
